<template>
    <div class="subPage">
        <!-- 头部 -->
        <Header
            :selectMemberType="selectMemberType"
            :changeSelectMemberType="changeSelectMemberType"
            :nexus="nexus"
        />
        <!-- 具体内容页 -->
        <!-- 零售 -->
        <RetailTable
            v-if="initRetail && initTeam && selectMemberType === 'retail'"
            :nexusRetailLevelUsers="nexusRetailLevelUsers"
            :nexusRetailLevelOverview="nexusRetailLevelOverview.filter(s => s.treeLevel !== 0)"
            :memberScoreType="memberScoreType"
        />
        <!-- 团队 -->
        <TeamTable
            v-if="initRetail && initTeam && selectMemberType === 'team'"
            :nexusTeamLevelUsers="nexusTeamLevelUsers"
            :nexusTeamLevelOverview="nexusTeamLevelOverview.filter(s => s.treeLevel !== 1)"
            :memberScoreType="memberScoreType"
        />
        <!-- 粉丝 -->
        <FansTable
            :fansSummary="fansSummary"
            v-if="initRetail && initTeam && selectMemberType === 'fans'"
            :fansBy="fansBy"
            :selectFansBy="selectFansBy"
            :fansList="fansList"
            :fans="fans"
        />
      <go-back-home/>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Header from '../userMemberElement/Header';
import RetailTable from '../userMemberElement/RetailTable';
import TeamTable from '../userMemberElement/TeamTable';
import FansTable from '../userMemberElement/FansTable';
import Router from '../../router/router';

export default {
  watch: {
      nexusRetailLevelOverview: function(value) {
          // 处理vue无法监听数组变化
          this.initRetail = true;
      },
      nexusTeamLevelOverview: function(value) {
          // 处理vue无法监听数组变化
          this.initTeam = true;
      },
      fansList: function(value) {
          // 处理vue无法监听数组变化
          this.initFans = true;
      }
  },

  props :['selectMemberType'],
  name: 'Member',
  meta:{page:true},
  data() {
    return {
        initRetail: false,
        initTeam: false,
        initFans: false
    }
  },

  computed: {
        ...mapGetters('userinterface', {
            memberScoreType: 'getMemberScoreType',
            fansBy: 'getFansBy'
        }),
        ...mapGetters('user', {
            userInfo: 'getUserInfo',
            nexusRetailLevelOverview: 'getNexusRetailLevelOverview',
            nexusRetailLevelUsers: 'getNexusRetailLevelUsersw',
            nexusTeamLevelOverview: 'getNexusTeamLevelOverview',
            nexusTeamLevelUsers: 'getNexusTeamLevelUsersw',
            nexus: 'getNexus',
            fansList: 'getFansList',
            fans: 'getFans',
            fansSummary: 'getFansSummary'
        })
  },
  methods: {

        ...mapActions('userinterface', [
        'selectFansBy'
    ]),

    changeSelectMemberType(type){
        //应用到route这样就改变了params也改变props
        Router.replace({name :'member',params:{selectMemberType:type}});
    }
  },

  created() {
  	  this.$store.dispatch('user/getUserInfo')
      this.$store.dispatch('user/getFansList')
      this.$store.dispatch('user/getFans', 'day')
      this.$store.dispatch('user/getFansSummary')

	  setTimeout(() => {
	     if (this.userInfo.teamAgent) {
          	this.$store.dispatch('user/getNexusTeamLevel')
	      } else {
	          this.initTeam = true;
	      }

	      if (this.userInfo.retailAgent) {
	      	 this.$store.dispatch('user/getNexusRetailLevel')
	      } else{
	      	this.initRetail = true;
	      }

	  }, 1000);


  },
  components: {
      Header,
      RetailTable,
      TeamTable,
      FansTable
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/page/Member.vue